<template>
  <div>
    <v-autocomplete
      v-model="displayTextSelected"
      :items="items"
      :search-input.sync="search"
      :label="label"
      :placeholder="placeholder"
      :item-text="itemText"
      :item-value="itemValue"
      :return-object="returnObject"
      hide-no-data
      :no-filter="true"
      :rules="rules"
      :filled="filled"
      :required="required"
      :readonly="readonly"
      :clearable="clearable"
      :prepend-inner-icon="prependInnerIcon"
      :append-outer-icon="appendOuterIcon"
      @click:append-outer="clickAppendOuter"
    >
    </v-autocomplete>
  </div>
</template>

<script lang="ts">
import Vue from "vue";
import contactApi from "@/api/contactApi";

export default Vue.extend({
  props: {
    value: {
      required: true,
    },
    contactId: {},
    projectId: {},
    label: {
      type: String,
      required: true,
    },
    placeholder: {
      default: "Søk etter kontaktperson (minimum 3 tegn)",
    },
    itemValue: {
      default: "fullNameAndCompanyName",
    },
    itemText: {
      default: "display",
    },
    minInputLength: {
      default: 3,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    returnObject: {
      type: Boolean,
      default: true,
    },
    filled: {
      type: Boolean,
      default: true,
    },
    required: {
      type: Boolean,
      default: false,
    },
    clearable: {
      type: Boolean,
      default: true,
    },
    prependInnerIcon: {
      default: "",
    },
    appendOuterIcon: {
      default: "",
    },
    rules: {
      default: () => [],
    },
  },
  data() {
    return {
      items: [],
      search: null,
      haveContactId: false,
      displayTextSelectedTest: "",
    };
  },
  async mounted() {
    if (this.compContactId && this.contactPersonId) {
      this.haveContactId = true;
      await contactApi
        .searchContactPersons(
          null,
          null,
          this.contactPersonId,
          this.compContactId
        )
        .then((response) => {
          this.items = response;

          var contactPerson = (this as any).items.find(
            (x) => (x.contactPersonId = this.contactPersonId)
          );
          this.displayTextSelectedTest = contactPerson
            ? contactPerson.fullNameAndCompanyName
            : "";
        });
    }
  },
  methods: {
    clickAppendOuter() {
      this.$emit("click:append-outer");
    },
  },
  watch: {
    search(newValue: any) {
      if (this.haveContactId) {
        this.haveContactId = false;
      } else {
        if (newValue && newValue.length >= this.minInputLength) {
          contactApi
            .searchContactPersons(this.projectId, newValue, null, null)
            .then((response) => {
              this.items = response;
            });
        } else {
          this.items = [];
        }
      }
    },
  },
  computed: {
    displayTextSelected: {
      get(): string {
        return this.displayTextSelectedTest;
      },
      set(value: any) {
        this.displayTextSelectedTest = value?.fullNameAndCompanyName
          ? value.fullNameAndCompanyName
          : value;

        this.compContactId = value?.contactId ? value.contactId : value;
        // this.$emit(
        //   "input",
        //   value && value.contactPersonId ? value.contactPersonId : value
        // );
        this.contactPersonId = value?.contactPersonId
          ? value.contactPersonId
          : value;
      },
    },
    contactPersonId: {
      get(): any {
        return this.value;
      },
      set(value: any) {
        // this.compContactId = value && value.contactId ? value.contactId : value;
        this.$emit("input", value);
      },
    },
    compContactId: {
      get(): any {
        return this.contactId;
      },
      set(value: any) {
        this.$emit("update:contactId", value);
      },
    },
  },
});
</script>
